import { render, staticRenderFns } from "./MessageInput.vue?vue&type=template&id=735d90d2&scoped=true"
import script from "./MessageInput.vue?vue&type=script&lang=ts"
export * from "./MessageInput.vue?vue&type=script&lang=ts"
import style0 from "./MessageInput.vue?vue&type=style&index=0&id=735d90d2&scoped=true&lang=css"
import style1 from "./MessageInput.vue?vue&type=style&index=1&id=735d90d2&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735d90d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('735d90d2')) {
      api.createRecord('735d90d2', component.options)
    } else {
      api.reload('735d90d2', component.options)
    }
    module.hot.accept("./MessageInput.vue?vue&type=template&id=735d90d2&scoped=true", function () {
      api.rerender('735d90d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat-components/MessageInput.vue"
export default component.exports